// Theme ids
export const FETCH_THEMES_IDS = 'themes/FETCH_THEMES_IDS';
export const FETCH_THEMES_IDS_DATA = 'themes/FETCH_THEMES_IDS_DATA';
export const FETCH_THEMES_IDS_ERROR = 'themes/FETCH_THEMES_IDS_ERROR';

// Theme
export const FETCH_THEME = 'themes/FETCH_THEME';
export const FETCH_THEME_DATA = 'themes/FETCH_THEME_DATA';
export const FETCH_THEME_ERROR = 'themes/FETCH_THEME_ERROR';

// Clone Theme
export const CLONE_THEME = 'themes/CLONE_THEME';
export const CLONE_THEME_SUCCESS = 'themes/CLONE_THEME_SUCCESS';
export const CLONE_THEME_ERROR = 'themes/CLONE_THEME_ERROR';

// Fetch Theme Schema
export const FETCH_THEME_SCHEMA = 'themes/FETCH_THEME_SCHEMA';
export const FETCH_THEME_SCHEMA_SUCCESS = 'themes/FETCH_THEME_SCHEMA_SUCCESS';
export const FETCH_THEME_SCHEMA_ERROR = 'themes/FETCH_THEME_SCHEMA_ERROR';

// Edit Theme
export const EDIT_THEME = 'themes/EDIT_THEME';
export const EDIT_THEME_SUCCESS = 'themes/EDIT_THEME_SUCCESS';
export const EDIT_THEME_ERROR = 'themes/EDIT_THEME_ERROR';

// Delete Theme
export const DELETE_THEME = 'themes/DELETE_THEME';
export const DELETE_THEME_SUCCESS = 'themes/DELETE_THEME_SUCCESS';
export const DELETE_THEME_ERROR = 'themes/DELETE_THEME_ERROR';
